// extracted by mini-css-extract-plugin
export default {"container":"_606xC1IuEastbpldbpTTtW"};